import styled from 'styled-components';

export const WrapperSection = styled.section`
  padding: 15px;
`;

export const Title = styled.h2`
  margin-bottom: 15px;
  padding-left: 15px;
`;
